const AgencyStorefront = () => import('@/views/client/agency-storefront-view');
const AgencyMarketplace = () => import('@/views/client/agency-marketplace-view');
const StorefrontRequestView = () => import('@/views/storefront/storefront-request-view');
const StorefrontIndexView = () => import('@/views/storefront/storefront-index-view');
const StorefrontDesignView = () => import('@/views/storefront/storefront-design-view');
const StorefrontPreviewView = () => import('@/views/storefront/storefront-preview-view');
const PartnerRequestsView = () => import('@/views/agency/partner-requests-view');

export default [
    {
        path: '/Storefront',
        name: 'StorefrontIndex',
        component: StorefrontIndexView,
        meta: {
            type: 'Agency',
            isUiShown: true,
            pageClass: 'storefront-index-page',
            pageTitle: 'Vendor Storefront',
        },
    },
    {
        path: '/Agencies/:agencyId/Storefront',
        name: 'StorefrontIndexAgency',
        component: StorefrontIndexView,
        meta: {
            type: 'Agency',
            isUiShown: true,
            pageClass: 'storefront-index-page',
            pageTitle: 'Vendor Storefront',
        },
    },
    {
        path: '/Storefront/Design',
        name: 'StorefrontBuilder',
        component: StorefrontDesignView,
        meta: {
            type: 'agency',
            isUiShown: false,
            pageClass: 'storefront-design-page',
            pageTitle: 'Storefront Designer',
        },
    },
    {
        path: '/Agencies/:agencyId/Storefront/Design',
        name: 'AgencyStorefrontBuilder',
        component: StorefrontDesignView,
        meta: {
            type: 'agency',
            isUiShown: false,
            pageClass: 'storefront-design-page',
            pageTitle: 'Storefront Designer',
        },
    },
    {
        path: '/Storefront/:storefrontAgencyId',
        name: 'Storefront',
        component: AgencyStorefront,
        meta: {
            isUiShown: true,
            pageClass: 'agency-storefront-page',
            subtype: 'marketplace',
            pageTitle: 'Agency Storefront',
        },
    },
    {
        path: '/Storefront/Preview',
        name: 'StorefrontPreview',
        component: StorefrontPreviewView,
        meta: {
            isUiShown: false,
            pageClass: 'agency-storefront-preview-page',
            subtype: 'marketplace',
            pageTitle: 'Agency Storefront Preview',
        },
    },
    {
        path: '/Agencies/:agencyId/Storefront/Preview',
        name: 'StorefrontPreviewByAgencyId',
        component: StorefrontPreviewView,
        meta: {
            isUiShown: false,
            pageClass: 'agency-storefront-preview-page',
            subtype: 'marketplace',
            pageTitle: 'Agency Storefront Preview',
        },
    },
    {
        path: '/Marketplace/Requests',
        name: 'MarketplaceRequests',
        component: StorefrontRequestView,
        meta: {
            type: 'organization',
            isUiShown: true,
            pageClass: 'storefront-request-page',
            pageTitle: 'Marketplace Requests',
        },
    },
    {
        path: '/Marketplace',
        name: 'Marketplace',
        component: AgencyMarketplace,
        meta: {
            isUiShown: true,
            subtype: 'marketplace',
            pageClass: 'agency-marketplace-page',
            pageTitle: 'Marketplace',
        },
    },
    {
        path: '/Agencies/:agencyId/Marketplace',
        name: 'MarketplaceAgencyView',
        component: AgencyMarketplace,
        meta: {
            type: 'agency',
            isUiShown: true,
            pageClass: 'agency-marketplace-page',
            pageTitle: 'Marketplace',
        },
    },
    {
        path: '/Clients/:clientId/Marketplace',
        name: 'MarketplaceClientView',
        component: AgencyMarketplace,
        meta: {
            type: 'agency',
            isUiShown: true,
            pageClass: 'agency-marketplace-page',
            subtype: 'marketplace',
            pageTitle: 'Marketplace',
        },
    },
    {
        path: '/MasterAgencies/:masterAgencyId/Marketplace',
        name: 'MarketplaceMasterAgencyView',
        component: AgencyMarketplace,
        meta: {
            type: 'master-agency',
            isUiShown: true,
            pageClass: 'agency-marketplace-page',
            subtype: 'marketplace',
            pageTitle: 'Marketplace',
        },
    },
    {
        path: '/PartnerRequests',
        name: 'Partner Requests',
        component: PartnerRequestsView,
        meta: {
            type: 'agency',
            isUiShown: true,
            pageClass: 'partner-requests-page',
            pageTitle: 'Partner Requests'
        }
    },
    {
        path: '/Agencies/:agencyId/PartnerRequests',
        name: 'PartnerRequestsByAgencyId',
        component: PartnerRequestsView,
        meta: {
            type: 'agency',
            isUiShown: true,
            pageClass: 'partner-requests-page',
            pageTitle: 'Partner Requests'
        }
    },
];
